<template>
  <v-dialog :value="true" max-width="500">
    <v-card>
      <v-card-title class="headline">Editar Configurações</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-select
            label="Tipo"
            v-model="fields.type.value"
            :items="fields.type.options"
            :rules="[...fields.type.rules]"
            outlined dense
          ></v-select>
          <!-- <v-select v-if="isBackoffice"
            label="Cashback"
            v-model="fields.cashback.value"
            :items="fields.cashback.options"
            outlined dense
          ></v-select>
          <v-select v-if="isBackoffice"
            label="Cashback Parceria"
            v-model="fields.cashbackPartner.value"
            :items="fields.cashbackPartner.options"
            outlined dense
          ></v-select>
          <v-select v-if="isBackoffice"
            label="Cashback do Experiência"
            v-model="fields.cashbackExperience.value"
            :items="fields.cashbackExperience.options"
            outlined dense
          ></v-select> -->
          <v-autocomplete v-if="asanaCelebrations && asanaCelebrations.length > 0 && !loading"
            label="ID ASANA"
            :items="asanaCelebrations"
            v-model="fields.asana.value"
            outlined dense
          ></v-autocomplete>
          <v-text-field v-else
            label="ID ASANA"
            v-model="fields.asana.value"
            outlined dense
          ></v-text-field>
          <v-text-field
            label="ID Pasta do Google Drive"
            v-model="fields.driveFolder.value"
            outlined dense
          ></v-text-field>
          <v-textarea
            label="Detalhes sobre a turma"
            v-model="fields.content.value"
            outlined dense
            rows="4"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'settingsModal',
  props: {
    settings: {
      required: true,
      type: Object
    },
    celebrationId: {
      required: true,
      type: String
    }
  },
  data: () => ({
    loading: false,
    saving: false,
    fields: {
      type: {
        value: null,
        rules: [
          v => !!v || 'O tipo é obrigatório'
        ],
        options: [
          { value: 'prospect', text: 'PROSPECT' },
          { value: 'plan', text: 'PLANO' },
          { value: 'payuse', text: 'PAY USE (SEM PLANO)' }
        ]
      },
      cashback: {
        value: null,
        options: [
          { value: null, text: 'Sem cashback' },
          { value: 0, text: '0%' },
          { value: 1, text: '1%' },
          { value: 1.5, text: '1,5%' },
          { value: 2, text: '2%' },
          { value: 2.5, text: '2,5%' },
          { value: 3, text: '3%' }
        ]
      },
      cashbackPartner: {
        value: null,
        options: [
          { value: null, text: 'Sem cashback' },
          { value: 'amigo-0.5', text: '+ 0,5% AMIGO' }
        ]
      },
      cashbackExperience: {
        value: null,
        options: [
          { value: false, text: 'Não' },
          { value: true, text: 'Sim' }
        ]
      },
      asana: {
        value: null
      },
      driveFolder: {
        value: null
      },
      content: {
        value: null
      }
    },
    errorMessage: null,
    hasCashback: false,
    asanaCelebrations: []
  }),
  computed: {
    ...mapGetters(['isBackoffice']),
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.hasCashback) data[key] = this.fields[key].value
        else if (this.fields[key]) data[key] = this.fields[key].value || null
      }
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    saveItem () {
      this.saving = true
      this.$firestore.collection('settings').doc(this.celebrationId).set({ ...this.apiData }, { merge: true })
        .then(() => {
          this.SET_SNACKBAR({ text: 'Configurações atualizadas' })
          this.$emit('ok')
        })
        .catch(() => {
          this.errorMessage = 'Houve um erro ao processar seu pedido, por favor tente novamente'
        })
        .finally(() => {
          this.saving = false
        })
    }
  },
  created () {
    if (!this.celebrationId) {
      this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
      this.$emit('canceled')
    }

    this.loading = true
    this.$store.dispatch('asanaApi', { method: 'GET', url: 'custom_fields/1207534182103018' })
      .then(response => {
        if (response && response.data && response.data.enum_options) {
          this.asanaCelebrations = response.data.enum_options.map(item => ({
            value: item.gid,
            text: item.name
          }))
        } else {
          this.asanaCelebrations = []
        }
      })
      .catch(() => {
        this.asanaCelebrations = []
      })
      .finally(() => {
        this.loading = false
      })

    for (let key in this.fields) {
      if (this.settings && this.settings[key]) this.fields[key].value = this.settings[key]
      else this.fields[key].value = ''
      if (this.settings && this.settings[key] && key === 'cashback') this.hasCashback = true
    }
  }
}
</script>
